module.exports = __webpack_public_path__ + "static/img/logo-100.37ed35ba.png";